
import React from 'react'
import Forms from '../components/LoginForm/Forms'

function Login() {
    return(
    <div>
        <Forms />
    </div> 
    )
}

export default Login